var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"hub_vibezz"}},[_vm._m(0),_vm._m(1),_c('div',{staticClass:"content-movie"},[_c('estados')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"poster"},[_c('img',{staticClass:"img-responsive",attrs:{"alt":"Vue logo","src":require("@/assets/cartaz.jpg")}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"poster-mobile"},[_c('img',{staticClass:"img-responsive",attrs:{"src":require("../assets/cartaz-mobile.jpg")}})])
}]

export { render, staticRenderFns }